import * as React from 'react';

export default class MenuItem extends React.Component {
  render() {
    return (
        <li>
            {this.props.children}
        </li>
    );
  }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-react-wrapper/src/menu/menuitem.tsx